import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedCog = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="settings" size="100%" color={stroke ?? color} />
);

export { LineRoundedCog };
